import Pike from "@dp/pike-message-web";

const BIZ_ID = "osg.rss.pike";

const endPointsMap = {
  production: ["pike.mykeeta.com"],
  test: ["pikem0.inf.test.sankuai.com"],
};

export const PikeConnection = {
  pikeInstance: null,

  async init(mis) {
    const nodeEnv = process.env.NODE_ENV;
    this.pikeInstance = new Pike(BIZ_ID, {
      env: ["staging", "production"].includes(nodeEnv) ? "product" : "test",
      keepAlive: true,
      alias: mis,
      // swimlane: "20313-alxhk",
      // isDebug: true,
      endPoints: endPointsMap[nodeEnv] || endPointsMap.test,
    });
    this.pikeInstance.start();
    this.pikeInstance.onStart(() => {
      console.log("pike 开始启动");
    });

    this.pikeInstance.open();
    this.pikeInstance.onOpenFail(() => {
      console.log("连接打开失败");
    });
    this.pikeInstance.onLoginFail((error, { extra }) => {
      console.log("登录鉴权失败");
      console.log(error, extra);
    });
    this.pikeInstance.onConnect(() => {
      console.log("建立连接成功");
    });
    this.pikeInstance.onConnectFail(() => {
      console.log("建立连接失败");
    });
    this.pikeInstance.onRouteFail((error) => {
      console.log(error);
    });
    this.pikeInstance.onDisconnect((reason, entryPoint) => {
      console.log("连接断开");
    });
    this.pikeInstance.onReady(() => {
      console.log("准备就绪");
    });
    return new Promise((resolve) => {
      resolve(this.pikeInstance);
    });
  },
  isReady() {
    return this.pikeInstance && this.pikeInstance.isReady();
  },
};
